/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { GuidId } from '../models/guid-id';
import { JsonPatchDocument } from '../models/json-patch-document';
import { Valuator } from '../models/valuator';

@Injectable({
  providedIn: 'root',
})
export class ValuatorsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getValuators
   */
  static readonly GetValuatorsPath = '/api/v1/Valuators';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getValuators$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getValuators$Plain$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<Valuator>>> {

    const rb = new RequestBuilder(this.rootUrl, ValuatorsService.GetValuatorsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Valuator>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getValuators$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getValuators$Plain(params?: {
  },
  context?: HttpContext

): Observable<Array<Valuator>> {

    return this.getValuators$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<Valuator>>) => r.body as Array<Valuator>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getValuators()` instead.
   *
   * This method doesn't expect any request body.
   */
  getValuators$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<Valuator>>> {

    const rb = new RequestBuilder(this.rootUrl, ValuatorsService.GetValuatorsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Valuator>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getValuators$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getValuators(params?: {
  },
  context?: HttpContext

): Observable<Array<Valuator>> {

    return this.getValuators$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<Valuator>>) => r.body as Array<Valuator>)
    );
  }

  /**
   * Path part for operation addValuator
   */
  static readonly AddValuatorPath = '/api/v1/Valuators';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addValuator$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addValuator$Plain$Response(params?: {
    body?: Valuator
  },
  context?: HttpContext

): Observable<StrictHttpResponse<GuidId>> {

    const rb = new RequestBuilder(this.rootUrl, ValuatorsService.AddValuatorPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GuidId>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addValuator$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addValuator$Plain(params?: {
    body?: Valuator
  },
  context?: HttpContext

): Observable<GuidId> {

    return this.addValuator$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<GuidId>) => r.body as GuidId)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addValuator()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addValuator$Response(params?: {
    body?: Valuator
  },
  context?: HttpContext

): Observable<StrictHttpResponse<GuidId>> {

    const rb = new RequestBuilder(this.rootUrl, ValuatorsService.AddValuatorPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GuidId>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addValuator$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addValuator(params?: {
    body?: Valuator
  },
  context?: HttpContext

): Observable<GuidId> {

    return this.addValuator$Response(params,context).pipe(
      map((r: StrictHttpResponse<GuidId>) => r.body as GuidId)
    );
  }

  /**
   * Path part for operation getValuatorById
   */
  static readonly GetValuatorByIdPath = '/api/v1/Valuators/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getValuatorById$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getValuatorById$Plain$Response(params: {
    id: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Valuator>> {

    const rb = new RequestBuilder(this.rootUrl, ValuatorsService.GetValuatorByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Valuator>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getValuatorById$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getValuatorById$Plain(params: {
    id: string;
  },
  context?: HttpContext

): Observable<Valuator> {

    return this.getValuatorById$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Valuator>) => r.body as Valuator)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getValuatorById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getValuatorById$Response(params: {
    id: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Valuator>> {

    const rb = new RequestBuilder(this.rootUrl, ValuatorsService.GetValuatorByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Valuator>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getValuatorById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getValuatorById(params: {
    id: string;
  },
  context?: HttpContext

): Observable<Valuator> {

    return this.getValuatorById$Response(params,context).pipe(
      map((r: StrictHttpResponse<Valuator>) => r.body as Valuator)
    );
  }

  /**
   * Path part for operation updateValuator
   */
  static readonly UpdateValuatorPath = '/api/v1/Valuators/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateValuator$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateValuator$Plain$Response(params: {
    id: string;
    body?: Valuator
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Valuator>> {

    const rb = new RequestBuilder(this.rootUrl, ValuatorsService.UpdateValuatorPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Valuator>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateValuator$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateValuator$Plain(params: {
    id: string;
    body?: Valuator
  },
  context?: HttpContext

): Observable<Valuator> {

    return this.updateValuator$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Valuator>) => r.body as Valuator)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateValuator()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateValuator$Response(params: {
    id: string;
    body?: Valuator
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Valuator>> {

    const rb = new RequestBuilder(this.rootUrl, ValuatorsService.UpdateValuatorPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Valuator>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateValuator$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateValuator(params: {
    id: string;
    body?: Valuator
  },
  context?: HttpContext

): Observable<Valuator> {

    return this.updateValuator$Response(params,context).pipe(
      map((r: StrictHttpResponse<Valuator>) => r.body as Valuator)
    );
  }

  /**
   * Path part for operation deleteValuatorById
   */
  static readonly DeleteValuatorByIdPath = '/api/v1/Valuators/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteValuatorById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteValuatorById$Response(params: {
    id: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ValuatorsService.DeleteValuatorByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteValuatorById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteValuatorById(params: {
    id: string;
  },
  context?: HttpContext

): Observable<void> {

    return this.deleteValuatorById$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation patchValuator
   */
  static readonly PatchValuatorPath = '/api/v1/Valuators/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchValuator$Plain()` instead.
   *
   * This method sends `application/json-patch+json` and handles request body of type `application/json-patch+json`.
   */
  patchValuator$Plain$Response(params: {
    id: string;
    body?: JsonPatchDocument
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Valuator>> {

    const rb = new RequestBuilder(this.rootUrl, ValuatorsService.PatchValuatorPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json-patch+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Valuator>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchValuator$Plain$Response()` instead.
   *
   * This method sends `application/json-patch+json` and handles request body of type `application/json-patch+json`.
   */
  patchValuator$Plain(params: {
    id: string;
    body?: JsonPatchDocument
  },
  context?: HttpContext

): Observable<Valuator> {

    return this.patchValuator$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Valuator>) => r.body as Valuator)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchValuator()` instead.
   *
   * This method sends `application/json-patch+json` and handles request body of type `application/json-patch+json`.
   */
  patchValuator$Response(params: {
    id: string;
    body?: JsonPatchDocument
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Valuator>> {

    const rb = new RequestBuilder(this.rootUrl, ValuatorsService.PatchValuatorPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json-patch+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Valuator>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchValuator$Response()` instead.
   *
   * This method sends `application/json-patch+json` and handles request body of type `application/json-patch+json`.
   */
  patchValuator(params: {
    id: string;
    body?: JsonPatchDocument
  },
  context?: HttpContext

): Observable<Valuator> {

    return this.patchValuator$Response(params,context).pipe(
      map((r: StrictHttpResponse<Valuator>) => r.body as Valuator)
    );
  }

}
